<template lang='pug'>
  v-tooltip(right)
    template(v-slot:activator='{on}')
      span(v-on='on') {{date | date}}
    span {{date | timeago}}
</template>

<script>
export default {
  name: 'TimeAgoReverse',
  props: {
    date: {
      required: true
    }
  }
};
</script>

<style scoped>
</style>
